import React from "react"
import { IMessageGroupDocument } from "../../models/documents/MessageGroupDocument"
import Table from "../../components/common/Table"
import { FontIcon, TableHeader, TableRow, TableHeaderColumn, TableRowColumn, TableBody  } from "material-ui"
import strings from "../../localization/strings"
import moment from "moment"

interface IProps {
    groups: IMessageGroupDocument[]
}

const MessageCenterGroupsTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <Table
            allowClickRow
            items={props.groups} 
            handleClickRow={(row) => {}}
            total={props.groups.length}
            offset={0}
            limit={100}
            limitOptions={null}
            onPageClick={()=>{}}
            onLimitChange={()=>{}}
            bodyStyle={{ overflow: "visible" }}
            readonly={true}
        >
            <TableHeader>
                <TableRow>
                    <TableHeaderColumn>{strings.Message}</TableHeaderColumn>
                    <TableHeaderColumn>{strings.Message_Group_Name}</TableHeaderColumn>
                    <TableHeaderColumn>{strings.Message_Context}</TableHeaderColumn>
                    <TableHeaderColumn>{strings.SentBy}</TableHeaderColumn>
                    <TableHeaderColumn>{strings.Date}</TableHeaderColumn>
                    <TableHeaderColumn style={{width: 55}}>{strings.Message_Members}</TableHeaderColumn>
                    <TableHeaderColumn style={{width: 55}}>{strings.Sent}</TableHeaderColumn>
                    <TableHeaderColumn style={{width: 25}}></TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody showRowHover deselectOnClickaway={false}>
                {props.groups && props.groups.map((row, i) =>
                    <TableRow key={i}>
                        <TableRowColumn title={row.SMSTokenTemplate.TemplateText}>{row.SMSTokenTemplate.TemplateText}</TableRowColumn>
                        <TableRowColumn title={row.Name}>{row.Name}</TableRowColumn>
                        <TableRowColumn title={row.ContextDescription}>{row.ContextDescription}</TableRowColumn>
                        <TableRowColumn title={row.SentByUserName}>{row.SentByUserName}</TableRowColumn>
                        <TableRowColumn title={moment(row.ObjectAudit.CreatedDate).format("MM/DD/YY HH:mma")}>{moment(row.ObjectAudit.CreatedDate).format("MM/DD/YY HH:mma")}</TableRowColumn>
                        <TableRowColumn title={row.TotalMessagesToSend} style={{width: 55}}>{row.TotalMessagesToSend}</TableRowColumn>
                        <TableRowColumn title={row.TotalSentMessages} style={{width: 55}}>{row.TotalSentMessages}</TableRowColumn>
                        <TableRowColumn style={{width: 25}}>
                            <FontIcon
                                id={`message-group-info-${row.Id}`}
                                className="fa fa-info-circle"
                                style={{ fontSize: 16, color: "#777777", cursor: "pointer" }}
                            />
                        </TableRowColumn>                        
                    </TableRow>
                )}
            </TableBody>

        </Table>   
    )
}

const tableCol: React.CSSProperties = {
    width: 120,
    textAlign: "center"
}

export default MessageCenterGroupsTable